import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShieldHalved } from '@fortawesome/free-solid-svg-icons/faShieldHalved';
import type { IconProps } from '../../types';

export function ShieldIcon({ 
  className, 
  size = 24, 
  color,
  'aria-label': ariaLabel = 'Shield',
}: IconProps) {
  return (
    <FontAwesomeIcon 
      icon={faShieldHalved}
      className={className}
      style={{ 
        width: typeof size === 'number' ? size : undefined,
        height: typeof size === 'number' ? size : undefined,
      }}
      color={color}
      aria-label={ariaLabel}
      role="img"
    />
  );
}
